import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetStructuredFareRule } from "@/src/actions/flightAction";
import { HiOutlineArrowSmRight } from "react-icons/hi";
import moment from "moment";
import FareOptionsCard from "./FareOptionsCard";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

export default function FareOptionsSheet({
  open,
  onOpenChange,
  flight,
  selectedFareKey,
  onSelectFare,
}) {
  const { flightSearchForm } = useSelector((state) => state.flights);
  const dispatch = useDispatch();
  
  const [allFareRules, setAllFareRules] = React.useState({});
  const [loadingMap, setLoadingMap] = React.useState({});

  const odDetails = flight.OriginDest;

  React.useEffect(() => {
    if (open && flight && (flight.SupplierID === "0F37D3CC-771A-EA11-8115-00155D1DC800" || flight.SupplierID === "4F803035-7738-F011-90F7-020077790001")) {
      flight.FareOptions.forEach(option => {
        if (!allFareRules[option.BookingKey]) {
          fetchRulesForOption(option);
        }
      });
    }
  }, [open, flight]);

  const fetchRulesForOption = (option) => {
    setLoadingMap(prev => ({ ...prev, [option.BookingKey]: true }));
    const payload = {
      SupplierID: flight.SupplierID,
      Supplier: flight.SupplierID,
      InventoryID: flight.InventoryID.toString(),
      FareBookingKey: option.BookingKey,
      PrevTranID: localStorage.getItem("transId") || flight.Id,
      OriginDestinations: odDetails.map(od => ({
        Origin: od.Origin,
        Destination: od.Destination,
        FlightNumber: od.FlightDetails[0].FlightNumber,
        MarketingCarrier: od.FlightDetails[0].MarketingAirline,
        OperatingCarrier: od.FlightDetails[0].OperatingAirlineCode || od.FlightDetails[0].MarketingAirline,
        ResBookDesigCode: od.FlightDetails[0].BookingClass,
        FareBasisCode: option.FareBreakDowns[0]?.FareBasisCode,
        DepartureDate: od.DepartureDateTime,
        ArrivalDate: od.ArrivalDateTime,
        BookingDate: moment().format()
      })),
      PassengerTypes: flightSearchForm.passengerType.map(p => ({
        Code: p.code,
        Count: p.quantity
      }))
    };

    dispatch(GetStructuredFareRule(payload, (resp) => {
      setLoadingMap(prev => ({ ...prev, [option.BookingKey]: false }));
      if (resp && resp.IsSuccess) {
        setAllFareRules(prev => ({ ...prev, [option.BookingKey]: resp }));
      }
    }));
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-[720px] lg:min-w-[85vw] flex-col flex h-dvh p-0 gap-0 overflow-hidden">
        <SheetHeader className="p-6 border-b bg-muted/30">
          <SheetTitle className="text-2xl font-bold">More Fare Options</SheetTitle>
          <div className="mt-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
             <div className="flex flex-col text-left">
                <div className="flex items-center gap-3 text-lg font-semibold">
                  <span>{odDetails[0].Origin}</span>
                  <HiOutlineArrowSmRight className="text-muted-foreground" />
                  <span>{odDetails[odDetails.length - 1].Destination}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground mt-1">
                  <img src={odDetails[0].FlightDetails[0].Logo} alt="" className="h-4 object-contain" />
                  <span>{odDetails[0].FlightDetails[0].Name}</span>
                  <span>•</span>
                  <span>{odDetails[0].FlightDetails[0].MarketingAirline}{odDetails[0].FlightDetails[0].FlightNumber}</span>
                </div>
             </div>
          </div>
        </SheetHeader>

        <SheetDescription className="flex-1 overflow-auto p-6">
           <p className="text-muted-foreground mb-6">Compare fare brands and select the one that fits your needs.</p>
           <ScrollArea className="w-full whitespace-nowrap pb-4">
              <div className="flex gap-6">
                {flight.FareOptions.map((option) => (
                  <FareOptionsCard
                    key={option.BookingKey}
                    option={option}
                    rules={allFareRules[option.BookingKey]}
                    loading={loadingMap[option.BookingKey]}
                    isSelected={selectedFareKey === option.BookingKey}
                    onSelect={(key) => {
                       onSelectFare(key);
                       onOpenChange(false);
                    }}
                  />
                ))}
              </div>
              <ScrollBar orientation="horizontal" />
            </ScrollArea>
        </SheetDescription>
      </SheetContent>
    </Sheet>
  );
}
